import { useState } from 'react'
import plus from './images/plus.svg'
import minus from './images/minus.svg'

const FAQS: { q: string; a: React.ReactNode }[] = [
  {
    q: '何本くらい届きますか？',
    a: (
      <>
        <p>本数は毎回お届けするバラの品種によって異なります。</p>
        <p>例えば、お花屋さんで1本1,500円ほどするような希少な大輪品種を3本お届けする回もあれば、スプレーバラや中輪バラを中心に6〜8本ほどさまざまな品種を楽しめる回もあります。</p>
        <p>バラは品種によって価格やボリュームが大きく異なるため、本数を揃えるのではなく、その時期に一番おすすめしたいバラを、その魅力が最も伝わる内容でお届けしています。</p>
      </>
    ),
  },
  {
    q: 'バラのトゲは取らない方がよいというのは本当ですか？',
    a: (
      <>
        <p>はい、基本的には取らないことをおすすめします。トゲを無理に取ってしまうと、茎に大きな傷がつき、そこから雑菌が入り病気になる原因になることもあります。また、若い枝の場合はトゲを取ることで枝の強度が落ち、折れやすくなるリスクもあります。そのため、トゲはついたままお届けしています。</p>
        <p>※小さなお子様がいるなど、トゲによるケガが不安な場合は取っていただいても問題ありません。</p>
      </>
    ),
  },
  {
    q: 'トゲを取りたい場合、安全に処理する方法はありますか？',
    a: <p>バラのトゲ取り（トゲ抜き）を使い、茎をやさしくなぞるようにして落とすのがおすすめです。2回目以降のお届け時に、バラのトゲ取りをセットで購入することができます。また、FLOWERアプリでも随時販売中ですので、お急ぎの場合はぜひこちらもご検討ください。</p>,
  },
  {
    q: 'いま注文するといつ届きますか？',
    a: <p>お申し込みから最短の日程でお届けします。申し込み画面にて、郵便番号入力後に確定の日付が表示されますので、ご確認ください。</p>,
  },
  {
    q: 'どのような手段で配送されますか？',
    a: <p>クロネコヤマトの宅急便でのお届けとなります。</p>,
  },
  {
    q: '受け取り時間帯を指定することはできますか？',
    a: <p>はい。商品の発送完了メールに記載されているクロネコヤマトの追跡URLより、受け取り時間帯を変更いただけます。クロネコメンバーズ（無料）に登録しておくと、次回以降は発送時にヤマト運輸からお届け予定の通知が届き、そこから直接受け取り日時の変更ができるようになります。また、ヤマト運輸公式アプリをインストールいただくとLINEと連携することも可能です。</p>,
  },
  {
    q: '夏期はクール便になりますか？',
    a: (
      <>
        <p>はい。夏期（5〜10月頃を予定）は、品質を保つためクール便でお届けします。この期間は1配送あたり税込330円が加算されます。</p>
        <p>※北海道エリアのみ、冬期（12〜3月頃予定）もクール便での配送となります。</p>
      </>
    ),
  },
  {
    q: '不在で受け取りができない時はどうすればいいですか？',
    a: <p>旅行や出張などで荷物の受け取りができない場合は、「受け取りを1週ずらす」もしくは「お届けのスキップ」でスケジュールの調整が可能です。次回発送の3日前の正午までに、マイページからお手続きをお願いします。</p>,
  },
  {
    q: '花器も同時に購入しました。一緒に届きますか？',
    a: <p>はい。お花と同じタイミングでお届けしますので、届いてすぐ飾っていただけます。</p>,
  },
  {
    q: '決済手段は何がありますか？',
    a: <p>クレジットカード（Visa・Mastercard・Amex・JCB・DinersClub・Discover）でお支払いいただけます。</p>,
  },
  {
    q: '領収書の発行はできますか？',
    a: <p>マイページ、もしくは商品の発送完了メール内に記載された領収書のダウンロードボタンから発行することができます。</p>,
  },
  {
    q: 'お届け頻度はあとから変更できますか？',
    a: <p>はい。次回発送の3日前の正午までに、マイページからお手続きください。</p>,
  },
  {
    q: 'お試しだけでもいいですか？',
    a: <p>はい。初回で停止していただくことも可能です。まずは一度、お試しください☺️</p>,
  },
  {
    q: 'スキップや解約はできますか？',
    a: <p>はい。FLOWERの定期便はいつでもスキップ・解約が可能です。次回発送の3日前の正午までにお手続きください。</p>,
  },
]

const FaqItem: React.FC<{ q: string; a: React.ReactNode; defaultOpen?: boolean }> = ({ q, a, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className="border-b border-white py-4">
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between gap-2 text-left cursor-pointer">
        <span className="flex gap-2 items-baseline text-[14px] font-bold text-black leading-normal">
          <span>Q.</span>
          <span>{q}</span>
        </span>
        <img src={open ? minus : plus} alt={open ? '閉じる' : '開く'} className="w-5 h-5 shrink-0" />
      </button>
      {open && <div className="pl-5 pt-2 text-[14px] leading-[1.6] text-[#858585]">{a}</div>}
    </div>
  )
}

export const FaqSection: React.FC = () => {
  return (
    <section id="faq" className="bg-bg py-14 px-6">
      <div className="max-w-md mx-auto flex flex-col gap-8">
        <div className="flex flex-col gap-2 items-center text-center">
          <p className="text-[16px] text-accent font-dm-serif font-medium">FAQ</p>
          <h2 className="text-[24px] font-bold text-black">よくあるご質問</h2>
        </div>
        <div className="flex flex-col">
          {FAQS.map((faq, index) => (
            <FaqItem key={faq.q} {...faq} defaultOpen={index === 0} />
          ))}
        </div>
      </div>
    </section>
  )
}
